class DispatchCode {
  constructor(title, hasNotification) {
    this.title = title;
    this.hasNotification = hasNotification;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      dispatchCodeId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',
      dispatchCodeManagmentInformationTableHeaders: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'عنوان', value: 'title', align: 'center' },
        { text: 'ارسال اعلان', value: 'notification', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      isActive: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن کدهای 800';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش کدهای 800';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getDispatchCodeFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.isActive = false;
      this.dispatchCode = new DispatchCode('', false);
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addDispatchCodeFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش کدهای 800';
        this.$refs.confirm.text = 'از ویرایش کدهای 800 اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف کدهای 800';
        this.$refs.confirm.text = 'از حذف کدهای 800 اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addDispatchCodeFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editDispatchCodeFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteDispatchCodeFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.dispatchCodeId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
